import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';
import API from '../service/api';
import { getMenuConfig, convertToMenuConfigs } from '../routes/menuUtils';
import {
  LOGIN_DATA,
  GET_HEADERMENU,
  GET_MENU,
  LOGIN_STATUS,
  LOGIN_ASYNC,
} from './rootReducer';

export const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

//  worker
export function* loginAsync() {
  let status = 0;
  try {
    const loginData = yield call(API.initLoginData);
    // MOCK DATA
    // const loginData = require('../../mock/data/login/initLoginData.json');
    yield delay(500);
    if (loginData.errCode === '00') {
      const menuData = convertToMenuConfigs(
        loginData.menuInfo.menuList,
        getMenuConfig(),
        '',
        loginData.buttonInfoList
      );
      yield put({ type: LOGIN_DATA, loginData: loginData || {} });
      yield put({ type: GET_MENU, menuData });
      status = 1;
    } else {
      yield put({ type: LOGIN_DATA, loginData: loginData || {} });
      status = 2;
    }
  } catch (err) {
    console.log(err);
    status = 2;
  }
  yield put({ type: LOGIN_STATUS, status });
}

// watcher
export default function* watchRootSagas() {
  yield takeLatest(LOGIN_ASYNC, loginAsync);
}



// WEBPACK FOOTER //
// ./src/views/saga.js